"use strict";import{Theme as e}from"./src/Theme.js";customElements.define("sp-theme",e);
//# sourceMappingURL=sp-theme.js.map
